module.exports = __webpack_public_path__ + "fonts/db_helvethaicaais_x_v3.2-webfont.27fb7a1c.eot";